import useSystemSettings from 'core/hooks/useSystemSettings';
import * as coreEntities from 'core/store/index';
import { getCustomizedBy } from 'core/utils/course';
import { isDisregardedProgram } from 'core/utils/user';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCourse } from './useCourse';
import { useUser } from './useUser';

export function useCourseItems(courseGuid) {
  const dispatch = useDispatch();
  const currentCourseItems = useSelector((state) => coreEntities.courses.selectors.getCurrentCourseItems(state));
  const { user, schoolGuid } = useUser();
  const { data: course } = useCourse(courseGuid);
  const { enableOverlays } = useSystemSettings();
  const [loading, setLoading] = useState(true);
  const [courseItems, setCourseItems] = useState([]);

  useEffect(() => {
    if (!courseGuid || !course?.guid || !user) return;
    if (currentCourseItems.items && currentCourseItems.courseGuid === courseGuid) {
      setCourseItems(currentCourseItems.items);
      setLoading(false);
    }
    if (!currentCourseItems.items || courseGuid !== currentCourseItems.courseGuid) {
      dispatch(
        coreEntities.courses.actions.fetchCourseItems({
          courseGuid,
          schoolGuid,
          customizedBy: getCustomizedBy(course, user),
          enableOverlays: enableOverlays,
          isDisregardedProgram: course?.school_group_guid ? false : true,
        })
      );
    }
  }, [currentCourseItems, courseGuid, course, user, schoolGuid, enableOverlays]);

  const refetch = () => {
    if (!courseGuid || !course || !user || !schoolGuid) return;

    // Set loading without clearing items to avoid flickering
    setLoading(true);

    // Dispatch fetch action with force flag to bypass saga's cache check
    dispatch(
      coreEntities.courses.actions.fetchCourseItems({
        courseGuid,
        schoolGuid,
        customizedBy: getCustomizedBy(course, user),
        enableOverlays: enableOverlays,
        isDisregardedProgram: isDisregardedProgram(course),
        force: true, // Force refetch even if items already exist
      })
    );
  };

  return { courseItems, loading, refetch };
}
